import HttpClient from '../httpClient';
import {
  AssistantBootstrap,
  AssistantMessage,
  AssistantPageContext,
  AssistantResponse,
} from '../../types/assistant';

class AssistantController extends HttpClient {
  bootstrap = async (authToken: string) => {
    const response = await this.client.get('/assistant/bootstrap', {
      headers: {
        Authorization: authToken,
      },
    });
    return response.data?.data as AssistantBootstrap;
  };

  sendMessage = async (
    payload: {
      sessionId: string;
      message: string;
      recentMessages: Pick<AssistantMessage, 'role' | 'content'>[];
      pageContext: AssistantPageContext;
    },
    authToken: string,
  ) => {
    const response = await this.client.post('/assistant/message', payload, {
      headers: {
        Authorization: authToken,
      },
    });
    return response.data?.data as AssistantResponse;
  };

  sendFeedback = async (
    payload: {
      sessionId: string;
      messageId: string;
      rating: 'yes' | 'no';
    },
    authToken: string,
  ) => {
    await this.client.post('/assistant/feedback', payload, {
      headers: {
        Authorization: authToken,
      },
    });
  };
}

export default new AssistantController(
  process.env.REACT_APP_API_URL_ENTERPRISE,
);
